import styled, { css } from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'
import { Select } from '@at/design-system-elements'

export const StyledSelect = styled(Select)`
    ${({ theme, disabled }) => css`
        pointer-events: ${disabled && 'none'};
        & > label {
            color: ${disabled && ThemeSelectors.getDarkDefaultColor(theme)};
        }
    `}
`
